import React, { Component } from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'
import utils from '../lib/utils'
import UserUtils from '../lib/UserUtils'
import { connect } from 'react-redux'
import { withRouter, Switch, Route } from 'react-router-dom'

import SidebarContent from '../components/SidebarContent'
import SidebarUsers from '../components/SidebarUsers'
import SiteNav from '../components/SiteNav'
import Loading from '../components/Loading'

import { save as saveType } from '../actions/types'
import { save as saveGroup } from '../actions/groups'
import { manageSidebar } from '../actions/ui'

@withRouter
@connect((state, props) => {
  return {
    loaded: !!state.sites.current,
    stateKey: utils.sectionKey(props.location.pathname),
    manage: state.ui.manageSidebar,
    sites: state.sites.sites,
    types: state.types,
    roles: state.roles
  }
})
export default class Sidebar extends Component {
  state = {
    saving: false
  }

  static contextTypes = {
    site: PropTypes.object
  }

  static childContextTypes = {
    editing: PropTypes.bool
  }

  getChildContext () {
    return {editing: this.props.manage}
  }

  onManageSidebar = e => {
    e.preventDefault()
    this.props.dispatch(manageSidebar())
  }

  onManageDone = async (e) => {
    e.preventDefault()
    const {dispatch, stateKey, types, roles} = this.props
    const {site} = this.context
    this.setState({saving: true})

    if (site.groups) {
      await Promise.all(site.groups.map(group =>
        dispatch(saveGroup(group, site.id, group.id))
      ))
    }

    if (stateKey === 'types') {
      await Promise.all(types.map(type =>
        dispatch(saveType(type, type.id, 'type'))
      ))
    } else if (stateKey === 'roles') {
      await Promise.all(roles.map(role =>
        dispatch(saveType(role, role.id, 'user_role'))
      ))
    }

    this.setState({saving: false})
    dispatch(manageSidebar())
  }

  render () {
    const {sites, manage, stateKey, location} = this.props
    const {site} = this.context
    const canManageSidebar = UserUtils.can(site, 'update', stateKey === 'roles' ? 'user_role' : 'content_type')

    if (!this.props.loaded) return null

    return <aside className={cn('fixed-side', {manage})}>
      <SiteNav sites={sites} site={site} url={location.pathname} />
      <div className='save-modal'>
        {manage &&
          <div>
            {this.state.saving
              ? <Loading type='container' />
              : <button className='btn' type='button' onClick={this.onManageDone}>
                Apply
              </button>
            }
          </div>
        }
      </div>
      <Switch>
        <Route path='/:siteId/users' component={SidebarUsers} />
        <Route path='/:siteId/content' component={SidebarContent} />
        <Route path='/:siteId/edit' component={SidebarContent} />
      </Switch>
      <section className='footer'>
        {canManageSidebar &&
          <a role='button' className='footer-item' onClick={this.onManageSidebar}>Manage Sidebar</a>
        }
      </section>
    </aside>
  }
}



// WEBPACK FOOTER //
// ./app/containers/Sidebar.js